var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1886 10.8969C14.5791 10.5064 15.2123 10.5064 15.6028 10.8969C15.9933 11.2874 15.9933 11.9206 15.6028 12.3111L11.4309 16.483C10.8639 17.05 10.831 18.0045 11.4309 18.6044C12.0308 19.2042 12.9852 19.1713 13.5522 18.6044L21.3304 10.8262C22.932 9.22456 22.8444 6.68333 21.3304 5.16933C19.8164 3.65533 17.2751 3.5677 15.6735 5.16933L7.89533 12.9475C5.3446 15.4982 5.39217 19.6367 7.89533 22.1399C10.3985 24.6431 14.537 24.6906 17.0877 22.1399L21.2597 17.968C21.6502 17.5774 22.2833 17.5774 22.6739 17.968C23.0644 18.3585 23.0644 18.9917 22.6739 19.3822L18.5019 23.5541C15.1628 26.8933 9.75815 26.8311 6.48112 23.5541C3.20409 20.2771 3.14197 14.8724 6.48112 11.5333L14.2593 3.75512C16.6646 1.3498 20.4705 1.48104 22.7446 3.75512C25.0187 6.02919 25.1499 9.83508 22.7446 12.2404L14.9664 20.0186C13.6393 21.3456 11.4202 21.4221 10.0167 20.0186C8.61308 18.615 8.6896 16.3959 10.0167 15.0688L14.1886 10.8969Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachOutline);
export default __webpack_public_path__ + "static/media/attach_outline.3fff018e823df156bb106c2343487c64.svg";
export { ForwardRef as ReactComponent };